import { Dashboard, CustomItem } from 'devexpress-dashboard/model'
import { CustomItemViewer, ResourceManager } from 'devexpress-dashboard/common'
import { FormItemTemplates } from 'devexpress-dashboard/designer'
import dxTreeView from 'devextreme/ui/tree_view';

var svgIcon = '<svg id="treeViewItemIcon" viewBox="0 0 24 24"><path stroke="#ffffff" fill="#f442ae" d="M12 2 L2 22 L22 22 Z" /></svg>';
var treeViewItemMetaData = {
	// bindings: [{
	// 	propertyName: 'measureValue',
	// 	dataItemType: 'Measure',
	// 	displayName: 'Value'
	// }, {
	// 	propertyName: 'dimensionValue',
	// 	dataItemType: 'Dimension',
	// 	displayName: 'Argument',
	// 	enableColoring: true,
	// 	enableInteractivity: true
	// }],
	interactivity: {
		filter: true
	},
	customProperties: [{
		ownerType: CustomItem,
		propertyName: 'treeViewIdProperty',
		valueType: 'string',
		defaultValue: 'treeView'
	}],
	optionsPanelSections: [{
		title: 'Custom',
		items: [{
			dataField: 'treeViewIdProperty',
			label: {
				text: 'Tree View Id'
			},
            editorType: "dxTextBox",
            editorOptions: {
                placeholder: "Tree View Id"
            }
		}]
	}],
	icon: 'treeViewItemIcon',
	title: 'Tree View'
};

class TreeViewItemViewer extends CustomItemViewer {
	constructor(model, $container, options) {		
        super(model, $container, options);
        this.dxTreeViewWidget = null;
        this.dxTreeViewWidgetSettings = undefined;
	}

    // _getDataSource() {
    //     var clientData = [];
    //     if (this.getBindingValue('measureValue').length > 0) {
    //         this.iterateData(function (dataRow) {
    //             clientData.push({
    //                 measureValue: dataRow.getValue('measureValue')[0],
    //                 dimensionValue: dataRow.getValue('dimensionValue')[0] || '',
    //                 dimensionDisplayText: dataRow.getDisplayText('dimensionValue')[0],
    //                 measureDisplayText: dataRow.getDisplayText('measureValue')[0],
    //                 dimensionColor: dataRow.getColor('dimensionValue')[0],
    //                 clientDataRow: dataRow
    //             });
    //         });
    //     }
    //     return clientData;
    // };

    _getdxTreeViewWidgetSettings() {
        var _this = this;
        var myData = {"frame":{"ElementId":"1","ShowName":"Frame 1: 844 bytes on wire (6752 bits), 128 bytes captured (1024 bits)"},"frame.encap_type":{"ElementId":"2","ParentElementId":"1","ShowName":"Encapsulation type: Linux cooked-mode capture (25)"},"frame.time":{"ElementId":"3","ParentElementId":"1","ShowName":"Arrival Time: Jan  4, 2021 10:29:03.009830000 GMT Standard Time"},"frame.offset_shift":{"ElementId":"4","ParentElementId":"1","ShowName":"Time shift for this packet: 0.000000000 seconds"},"frame.time_epoch":{"ElementId":"5","ParentElementId":"1","ShowName":"Epoch Time: 1609756143.009830000 seconds"},"frame.time_delta":{"ElementId":"6","ParentElementId":"1","ShowName":"Time delta from previous captured frame: 0.000000000 seconds"},"frame.time_delta_displayed":{"ElementId":"7","ParentElementId":"1","ShowName":"Time delta from previous displayed frame: 0.000000000 seconds"},"frame.time_relative":{"ElementId":"8","ParentElementId":"1","ShowName":"Time since reference or first frame: 0.000000000 seconds"},"frame.number":{"ElementId":"9","ParentElementId":"1","ShowName":"Frame Number: 1"},"frame.len":{"ElementId":"10","ParentElementId":"1","ShowName":"Frame Length: 844 bytes (6752 bits)"},"frame.cap_len":{"ElementId":"11","ParentElementId":"1","ShowName":"Capture Length: 128 bytes (1024 bits)"},"frame.marked":{"ElementId":"12","ParentElementId":"1","ShowName":"Frame is marked: False"},"frame.ignored":{"ElementId":"13","ParentElementId":"1","ShowName":"Frame is ignored: False"},"frame.protocols":{"ElementId":"14","ParentElementId":"1","ShowName":"Protocols in frame: sll:ethertype:ip:icmp:data"},"sll":{"ElementId":"15","ParentElementId":"0","ShowName":"Linux cooked capture"},"sll.pkttype":{"ElementId":"16","ParentElementId":"15","ShowName":"Packet type: Sent by us (4)"},"sll.hatype":{"ElementId":"17","ParentElementId":"15","ShowName":"Link-layer address type: 512"},"sll.halen":{"ElementId":"18","ParentElementId":"15","ShowName":"Link-layer address length: 0"},"sll.unused":{"ElementId":"19","ParentElementId":"15","ShowName":"Unused: 0000000000000000"},"sll.etype":{"ElementId":"20","ParentElementId":"15","ShowName":"Protocol: IPv4 (0x0800)"},"ip":{"ElementId":"21","ParentElementId":"0","ShowName":"Internet Protocol Version 4, Src: 10.69.69.207, Dst: 18.134.116.8"},"ip.version":{"ElementId":"22","ParentElementId":"21","ShowName":"0100 .... = Version: 4"},"ip.hdr_len":{"ElementId":"23","ParentElementId":"21","ShowName":".... 0101 = Header Length: 20 bytes (5)"},"ip.dsfield":{"ElementId":"24","ParentElementId":"21","ShowName":"Differentiated Services Field: 0x00 (DSCP: CS0, ECN: Not-ECT)"},"ip.dsfield.dscp":{"ElementId":"25","ParentElementId":"24","ShowName":"0000 00.. = Differentiated Services Codepoint: Default (0)"},"ip.dsfield.ecn":{"ElementId":"26","ParentElementId":"24","ShowName":".... ..00 = Explicit Congestion Notification: Not ECN-Capable Transport (0)"},"ip.len":{"ElementId":"27","ParentElementId":"21","ShowName":"Total Length: 828"},"ip.id":{"ElementId":"28","ParentElementId":"21","ShowName":"Identification: 0x09c8 (2504)"},"ip.flags":{"ElementId":"29","ParentElementId":"21","ShowName":"Flags: 0x0000"},"ip.flags.rb":{"ElementId":"30","ParentElementId":"29","ShowName":"0... .... .... .... = Reserved bit: Not set"},"ip.flags.df":{"ElementId":"31","ParentElementId":"29","ShowName":".0.. .... .... .... = Dont fragment: Not set"},"ip.flags.mf":{"ElementId":"32","ParentElementId":"29","ShowName":"..0. .... .... .... = More fragments: Not set"},"ip.frag_offset":{"ElementId":"33","ParentElementId":"21","ShowName":"Fragment offset: 0"},"ip.ttl":{"ElementId":"34","ParentElementId":"21","ShowName":"Time to live: 64"},"ip.proto":{"ElementId":"35","ParentElementId":"21","ShowName":"Protocol: ICMP (1)"},"ip.checksum":{"ElementId":"36","ParentElementId":"21","ShowName":"Header checksum: 0x9757 [validation disabled]"},"ip.checksum.status":{"ElementId":"37","ParentElementId":"21","ShowName":"Header checksum status: Unverified"},"ip.src":{"ElementId":"38","ParentElementId":"21","ShowName":"Source: 10.69.69.207"},"ip.addr":{"ElementId":"39","ParentElementId":"21","ShowName":"Source or Destination Address: 10.69.69.207"},"ip.src_host":{"ElementId":"40","ParentElementId":"21","ShowName":"Source Host: 10.69.69.207"},"ip.host":{"ElementId":"41","ParentElementId":"21","ShowName":"Source or Destination Host: 10.69.69.207"},"ip.dst":{"ElementId":"42","ParentElementId":"21","ShowName":"Destination: 18.134.116.8"},"ip.addr":{"ElementId":"43","ParentElementId":"21","ShowName":"Source or Destination Address: 18.134.116.8"},"ip.dst_host":{"ElementId":"44","ParentElementId":"21","ShowName":"Destination Host: 18.134.116.8"},"ip.host":{"ElementId":"45","ParentElementId":"21","ShowName":"Source or Destination Host: 18.134.116.8"},"icmp":{"ElementId":"46","ParentElementId":"0","ShowName":"Internet Control Message Protocol"},"icmp.type":{"ElementId":"47","ParentElementId":"46","ShowName":"Type: 8 (Echo (ping) request)"},"icmp.code":{"ElementId":"48","ParentElementId":"46","ShowName":"Code: 0"},"icmp.checksum":{"ElementId":"49","ParentElementId":"46","ShowName":"Checksum: 0xb09f [unverified] [fragmented datagram]"},"icmp.checksum.status":{"ElementId":"50","ParentElementId":"46","ShowName":"Checksum Status: Unverified"},"icmp.ident":{"ElementId":"51","ParentElementId":"46","ShowName":"Identifier (BE): 620 (0x026c)"},"icmp.ident":{"ElementId":"52","ParentElementId":"46","ShowName":"Identifier (LE): 27650 (0x6c02)"},"icmp.seq":{"ElementId":"53","ParentElementId":"46","ShowName":"Sequence number (BE): 1 (0x0001)"},"icmp.seq_le":{"ElementId":"54","ParentElementId":"46","ShowName":"Sequence number (LE): 256 (0x0100)"},"icmp.data_time":{"ElementId":"55","ParentElementId":"46","ShowName":"Timestamp from icmp data: Jan  4, 2021 10:29:03.000000000 GMT Standard Time"},"icmp.data_time_relative":{"ElementId":"56","ParentElementId":"46","ShowName":"Timestamp from icmp data (relative): 0.009830000 seconds"},"data":{"ElementId":"57","ParentElementId":"46","ShowName":""},"data.data":{"ElementId":"58","ParentElementId":"57","ShowName":"Data: 6925000000000000101112131415161718191a1b1c1d1e1f\\xe2\\x80\\xa6"},"data.len":{"ElementId":"59","ParentElementId":"57","ShowName":"Length: 76"}}
        
        var arrayVal = [];
        Object.keys(myData).forEach(key => arrayVal.push(myData[key]));
        console.log(window.$pcapdata);
        arrayVal.forEach(item => {
            if(item.ParentElementId === 0){

            }
        })
        return {
            //dataSource: arrayVal,
            elementAttr: {
                id: "treeView"
            },
            selectByClick: false,
              searchEnabled: true,
              dataStructure: 'plain',
              parentIdExpr: 'ParentElementId',
              keyExpr: 'ElementId',
            displayExpr: 'ShowName',
            
        };
    }

    setSelection() {
        var _this = this;
        this.dxTreeViewWidget.getAllItems().forEach(function (item) {
            item.select(_this.isSelected(item.data.clientDataRow));
        });
    }

    clearSelection() {
        this.dxTreeViewWidget.clearSelection();
    }

    // setSize(width, height) {
    //     Object.getPrototypeOf(TreeViewItemViewer.prototype).setSize.call(this, width, height);
    //     this.dxTreeViewWidget.render();
    // }

    renderContent(element, changeExisting) {
        if (!changeExisting) {

            while (element.firstChild)
                element.removeChild(element.firstChild);

            var div = document.createElement('div');
            div.style.width = "100%";
            div.style.height = "100%";
            element[0].appendChild(div);
            this.dxTreeViewWidget = new dxTreeView(div, this._getdxTreeViewWidgetSettings());
        } else {
            this.dxTreeViewWidget.option(this._getdxTreeViewWidgetSettings());
        }
    }
}
class TreeViewItem {
    constructor(dashboardControl) {
        ResourceManager.registerIcon(svgIcon);
        this.name = "treeViewCustomItem";
		this.metaData = treeViewItemMetaData;
    }

    createViewerItem(model, $element, content) {
        return new TreeViewItemViewer(model, $element, content);
    }
}

export default TreeViewItem;